// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ZBc2","header":"PatientQuestionnaire_header__YXFoy","info":"PatientQuestionnaire_info__Q51mA"};